// extracted by mini-css-extract-plugin
module.exports = {"infoText":"results_infoText__tG7g_","warn":"results_warn__S3Uxr","error":"results_error__y_Q_5","spinner":"results_spinner___DgWB"};